module.exports = __webpack_public_path__ + "img/4.3fd1695a.png";